import React, { createClass, PropTypes } from 'react';
import $ from 'jquery';
import languagesObj from '../../localization/languages.json';
import { connect } from 'react-redux';
import { setOnboardingFields, submitOnboarding } from '../../stores/onboarding/onboarding-actions';
import { onBoardingComplete, getUser } from '../../stores/user/user-actions';
import { getProfile } from '../../stores/profile/company/profile-actions';
import { showOnboardingDialog } from '../../stores/dashboard/actions';
import InputForm from '../form';
import { Dialog, FlatButton } from 'material-ui';
import SectionHeading from '../tc-ui/section-heading';
import OnBoardingProfileImage from './on-boarding-profile-image';
import ContactInfo from './contact-info';
import AboutYourCompany from './about-your-company';
const languageSettings = languagesObj['en-US'];
import {
  compose,
  map,
  ifElse,
  equals,
  always,
  either,
  isNil,
  call,
  isEmpty,
  props,
  zipObj,
} from 'ramda';
const doesntExist = either(isNil, isEmpty);

const camelCase = (contactInformation) => {
  return {
    contactFirstName: contactInformation.first_name,
    contactLastName: contactInformation.last_name,
    contactEmail: contactInformation.email,
    contactPhone: contactInformation.phone,
  };
};

const OnBoarding = createClass({

  propTypes: {
    routeName: PropTypes.string,
    dispatch: PropTypes.func,
    user: PropTypes.object,
    onboarding: PropTypes.object,
    history: PropTypes.object,
  },

  getInitialState() {
    const { user, dispatch } = this.props;
    const { contactInformation } = user.company;
    const contactInfo = Object.keys(contactInformation).length ? camelCase(contactInformation) : {
      'firstName': user.firstName,
      'lastName': user.lastName,
    };
    const profileImageUrl = user.company.profileImageUrl ? `${user.company.profileImageUrl}?${new Date().getTime()}` : undefined;
    const prePopulateAddress = user.company.address || {};
    const sharedFields = {
      companyTypes: user.company.companyTypes,
      countriesServed: user.company.countriesServed,
      description: user.company.description,
      phone: user.company.phone,
      websiteUrl: user.company.websiteUrl,
      refreshDialog: false,
      addressDialog: false,
      oneOrMultiProperties: user.company.oneOrMultiProperties,
      singleLocId: user.company.singleLocId,
    };

    dispatch(setOnboardingFields(Object.assign({
      city: prePopulateAddress.city,
      companyAddressLineOne: prePopulateAddress.address_1,
      companyAddressLineTwo: prePopulateAddress.address_2,
      contactEmail: contactInfo.email,
      contactFirstName: contactInfo.firstName,
      contactLastName: contactInfo.lastName,
      contactPhone: contactInfo.phone,
      country: prePopulateAddress.country,
      marketSegments: user.company.segments,
      postalCode: prePopulateAddress.postal_code,
      state: prePopulateAddress.state,
    }, sharedFields)));
    // if (user.onBoardingStatus === 'verify') {
    //   dispatch(setOnboardingFields(Object.assign({
    //     city: prePopulateAddress.city,
    //     companyAddressLineOne: prePopulateAddress.address_1,
    //     companyAddressLineTwo: prePopulateAddress.address_2,
    //     contactEmail: contactInfo.email,
    //     contactFirstName: contactInfo.firstName,
    //     contactLastName: contactInfo.lastName,
    //     contactPhone: contactInfo.phone,
    //     country: prePopulateAddress.country,
    //     marketSegments: user.company.segments,
    //     postalCode: prePopulateAddress.postal_code,
    //     state: prePopulateAddress.state,
    //   }, sharedFields)));
    // } else {
    //   dispatch(setOnboardingFields({ country: prePopulateAddress.country }));
    // }
    // If no image display the default company logo
    return Object.assign({
      formattedAddressObj: {},
      onBoardingStatus: user.onBoardingStatus,
      prePopulateAddress: user.company.address,
      prePopulateContactInformation: contactInfo,
      productType: user.company.productType,
      segments: user.company.segments,
      selectedNo: 0,
      userCountry: user.userCountry,
      userType: user.user.type,
      profileImageUrl,
    }, sharedFields);
  },

  componentWillMount() {
    const { user, history } = this.props;
    if (user.onBoardingStatus === 'complete') {
      history.push('/');
      return false;
    }
  },

  onChange(event, componentName, multiSelectInputValue = []) {
    const { dispatch, onboarding } = this.props;
    if (event) {
      if (event.target.type === 'file') return undefined;
      if (onboarding[event.target.name] === event.target.value) return undefined;
      return dispatch(setOnboardingFields({ [event.target.name]: event.target.value }));
    } else if (componentName && multiSelectInputValue.length) {
      if (onboarding[componentName] && onboarding[componentName].length === multiSelectInputValue.length) return undefined;
      return dispatch(setOnboardingFields({ [componentName]: multiSelectInputValue }));
    }
  },

  // On form submit - verify address (fired if form is valid)
  onSubmit(event) {
    const { onboarding } = this.props;
    event.preventDefault();
    const addressToGeocode = ['companyAddressLineOne', 'city', 'country', 'state', 'postalCode'].reduce((addressToReturn, field, index) => {
      const value = onboarding[field];
      if (value) return addressToReturn + ((index ? ' ' : '') + value);
      return addressToReturn;
    }, '');
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({
      'address': addressToGeocode,
      'region': 'US',
    }, (results) => {
      const [result] = results;
      const formattedAddressObj = {};
      if (result) {
        formattedAddressObj.formattedAddress = result.formatted_address;
        result.address_components.forEach((component) => {
          if (component.types.indexOf('locality') > -1) formattedAddressObj.city = component.long_name;
          if (component.types.indexOf('administrative_area_level_1') > -1) formattedAddressObj.state = component.long_name;
          if (component.types.indexOf('postal_code') > -1) formattedAddressObj.postalCode = component.long_name;
        });
        formattedAddressObj.coordinates = [result.geometry.location.lng(), result.geometry.location.lat()];
      }
      this.setState({ formattedAddressObj }, () => this.confirmAddress());
    });
  },

  // If there is an error submitting then ask user to refresh page
  onBoardingError() {
    this.showDialog('refreshDialog');
  },

  // Refresh page on error with DB post
  onDialogRefresh() {
    window.location.reload();
  },

  // Shows formatted address for confirm dialog
  getAddress() {
    const { onboarding } = this.props;
    const { addressOne, addressTwo, everythingElse } = (() => {
      if (this.state.formattedAddressObj.formattedAddress) {
        const commaIndex = this.state.formattedAddressObj.formattedAddress.indexOf(',');
        const UKCheck = onboarding.country === 'United Kingdom' && onboarding.state !== this.state.formattedAddressObj.state ?
          `${onboarding.city}, ${this.state.formattedAddressObj.state} ${onboarding.postalCode}` : this.state.formattedAddressObj.formattedAddress.substr(commaIndex + 2);
        return {
          addressOne: this.state.formattedAddressObj.formattedAddress.substr(0, commaIndex),
          addressTwo: onboarding.companyAddressLineTwo,
          everythingElse: UKCheck,
        };
      }
      return {
        addressOne: onboarding.companyAddressLineOne,
        addressTwo: onboarding.companyAddressLineTwo,
        everythingElse: `${onboarding.city} ${onboarding.state} ${onboarding.country}`,
      };
    })();

    if (addressTwo) {
      return (
        `Is this your correct address?\n\n${addressOne}\n${addressTwo}\n${everythingElse}`
      );
    }
    return (
      `Is this your correct address?\n\n${addressOne}\n${everythingElse}`
    );
  },

  getTitle() {
    const { formattedAddress } = this.state.formattedAddressObj;
    if (formattedAddress) return 'We were able to verify your address.';
    return 'We were unable to verify your address.';
  },

  confirmAddress() {
    this.showDialog('addressDialog');
  },

  // submit form
  _onDialogSubmit() {
    this.dismissDialog('addressDialog');
    const { formattedAddress } = this.state.formattedAddressObj;
    const payload = formattedAddress ? this.state.formattedAddressObj : {};
    this.setState({ sent: true }, () => this.completedProfile(payload));
  },

  _onDialogSkip() {
    this.dismissDialog('addressDialog');
    this.setState({ sent: true }, () => this.completedProfile({}));
  },

  // else scroll back to address to fix
  _onDialogDeny() {
    this.dismissDialog('addressDialog');
    // increase count of times selected no by one
    this.setState({ selectedNo: this.state.selectedNo + 1 }, () => {
      // scroll to the address section
      const y = $('#address').offset().top - 64;
      // Necessary to wait for DOM to update classes
      setTimeout(() => {
        window.scrollTo(0, y);
      }, 500);
    });
  },

  dismissDialog(dialog) {
    this.setState({ [dialog]: false });
  },

  showDialog(dialog) {
    this.setState({ [dialog]: true });
  },

  // Transition to connections once onboarding is complete
  completedProfile(payload) {
    const { dispatch, onboarding, history } = this.props;
    dispatch(submitOnboarding(Object.assign(payload, onboarding)))
    .then(() => {
      this.dismissDialog('addressDialog');
      dispatch(onBoardingComplete());
      dispatch(showOnboardingDialog());
      dispatch(getUser(true));
      dispatch(getProfile());
      history.push('/dashboard');
    })
    .catch((err) => {
      console.log(err);
      return this.onBoardingError();
    });
  },

  giveUrl(url) {
    const { dispatch } = this.props;
    dispatch(setOnboardingFields({ profileImageUrl: url }));
  },

  render() {
    const { onboarding } = this.props;
    if (!this.state.userType) return <div />;
    const onBoardingStatus = this.props.user.onBoardingStatus || '';
    const multiSelectTypes = call(
      ifElse(
        equals('Supplier'),
          always(['companyTypes', 'marketSegments']),
        always(['companyTypes', 'marketSegments', 'countriesServed'])
      )
    , this.state.userType);
    const getMultiSelectErrors = compose(
      zipObj(multiSelectTypes),
      map(doesntExist)
    );
    // This multiselect is shared amongst all users
    const { title, subtitle } = (() => {
      if (onBoardingStatus.toLowerCase() === 'verify') {
        return {
          title: languageSettings.onboarding.verifyTitle,
          subtitle: "We're making some changes that will help you connect with other partners.",
        };
      }
      return {
        title: languageSettings.onboarding.onBoardingTitle,
        subtitle: languageSettings.onboarding.onBoardingSubTitle,
      };
    })();

    const dialogActions = [
      <FlatButton
        label={languageSettings.onboarding.dialogYes}
        onTouchTap={this._onDialogSubmit}
        primary
        disabled={this.state.sent === true}
      />,
      <FlatButton
        label={languageSettings.onboarding.dialogNo}
        onTouchTap={this._onDialogDeny}
        secondary
      />,
    ];

    if (this.state.selectedNo) {
      dialogActions.push(
        <FlatButton
          label={languageSettings.onboarding.dialogSkip}
          onTouchTap={this._onDialogSkip}
          secondary
          disabled={this.state.sent === true}
        />,
      );
    }

    const refreshDialogActions = [
      <FlatButton
        label={languageSettings.onboarding.dialogRefreshButton}
        onTouchTap={this.onDialogRefresh}
        secondary
      />,
    ];
    return (
      <div className="l-app-content">
        <InputForm
          sent={this.state.sent}
          onChange={this.onChange}
          onSubmit={this.onSubmit}
          submitName={languageSettings.onboarding.submitButton}
          onBoardingState={this.props.onboarding}
          userType={this.state.userType}
          requiredFields
        >

          <SectionHeading
            title={title}
            subtitle={subtitle}
          />

            <OnBoardingProfileImage
              giveUrl={this.giveUrl}
              src={onboarding.profileImageUrl && `${onboarding.profileImageUrl}?${new Date().getTime()}`}
            />

            <AboutYourCompany
              onChange={this.onChange}
              dispatch={this.props.dispatch}
              onboarding={this.props.onboarding}
              multiSelectErrors={getMultiSelectErrors(props(multiSelectTypes, onboarding))}
              { ...this.state }
            />

            <ContactInfo
              onChange={this.onChange}
              phone={this.state.phone}
              prePopulateContactInformation={this.state.prePopulateContactInformation}
              prePopulateAddress={this.state.prePopulateAddress}
              dispatch={this.props.dispatch}
              onboarding={onboarding}
            />

        </InputForm>

        <Dialog
          className="form-dialog"
          title={languageSettings.onboarding.dialogErrorTitle}
          ref="refreshDialog"
          actions={refreshDialogActions}
          open={this.state.refreshDialog}
          onRequestClose={this.dismissDialog.bind(this, 'refreshDialog')}
        >
          {languageSettings.onboarding.dialogErrorMessage}
        </Dialog>

        <Dialog
          className="form-dialog"
          contentClassName="address-dialog-info"
          title={this.getTitle()}
          ref="addressDialog"
          actions={dialogActions}
          open={this.state.addressDialog}
          onRequestClose={this.dismissDialog.bind(this, 'dismissDialog')}
        >
          {this.getAddress()}
        </Dialog>
      </div>
    );
  },
});

const select = (state) => {
  return {
    onboarding: state.onboarding.toJS(),
  };
};

export default connect(select)(OnBoarding);



// WEBPACK FOOTER //
// ./src/app/components/onboarding/on-boarding.jsx